import { customerRoutePrefix, itineraryRoutePrefix, ltoRoutePrefix } from "@travellocal/utils/webRoutes";

interface EnquiryFormRouteParams {
  [key: string]: number | string | undefined;

  locationSlug?: string;

  itineraryId?: number;

  /**
   * #599 Each different route into the enquiry form should pass in a unique campaign string.
   */
  campaign: string;
}

/**
 * @deprecated Methods in this class should be moved to `@travellocal/utils/webRoutes`.
 */
export class RoutesInvoker {
  public static ENQUIRY_ROUTE_PREFIX = "/plan-your-trip";

  /** @deprecated use @travellocal/utils/webRoutes */
  public static login = (loggedOutReason?: string) => {
    let route = "/account/login";
    if (loggedOutReason && loggedOutReason.length > 0) {
      route += `?loggedOutReason=${loggedOutReason}`;
    }
    return route;
  }

  /** @deprecated use @travellocal/utils/webRoutes */
  public static logout = "/account/logout";

  public static forgottenPassword = () => "/account/request-forgotten-password";

  public static completeForgottenPassword = "/account/forgotten-password";

  /** @deprecated use @travellocal/utils/webRoutes */
  public static customerIndex = customerRoutePrefix;

  public static customerEnquiriesIndex(enquiryId: number, firstTime?: boolean) {
    return `/customer/enquiries/${enquiryId}${firstTime ? "?firstTime=true" : ""}`;
  }

  public static customerEnquiryTravellerDetails(enquiryId: number) {
    return "/customer/enquiries/" + enquiryId + "/traveller-details";
  }

  public static customerEnquiryReview(enquiryId: number) {
    return "/customer/enquiries/" + enquiryId + "/review";
  }

  public static bulma() {
    return "/dev/bulma";
  }

  public static lto = (ltoSlug: string) => `${ltoRoutePrefix}/${ltoSlug}`;

  public static itineraryGalleryImage = (itinerarySlug: string, fileName: string, isSampleItinerary: boolean) => {
    return (isSampleItinerary) ?
      `${itineraryRoutePrefix}/${itinerarySlug}/gallery/${fileName}` :
      `${customerRoutePrefix}/${itinerarySlug}/gallery/${fileName}`;
  }
}
